import React, { useState, useEffect } from 'react';
import mockOnetService from '../services/mockOnetService';
import OnetAttribution from '../components/OnetAttribution';

const MockOnetTest = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const testApi = async () => {
      setLoading(true);
      console.log('Testing Mock O*NET API...');
      
      try {
        // Test mock search
        const searchResult = await mockOnetService.searchOccupations('software', 3);
        console.log('Mock search result:', searchResult);

        // Test mock details
        const detailsResult = await mockOnetService.getOccupationDetails('15-1132');
        console.log('Mock details result:', detailsResult);

        // Test mock categories
        const categoriesResult = await mockOnetService.getOccupationCategories();
        console.log('Mock categories result:', categoriesResult);

        setResult({
          search: searchResult,
          details: detailsResult,
          categories: categoriesResult,
          timestamp: new Date().toISOString()
        });

      } catch (error) {
        console.error('Mock O*NET API Test Error:', error);
        setResult({ success: false, error: error.message });
      } finally {
        setLoading(false);
      }
    };

    testApi();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Mock O*NET API Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Configuration:</h3>
        <p><strong>Service:</strong> Mock O*NET Service (for development)</p>
        <p><strong>Purpose:</strong> Test O*NET functionality without API key</p>
        <p><strong>Data:</strong> Sample occupation data</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Test Status:</h3>
        {loading && <p>🔄 Testing Mock O*NET API...</p>}
        {result && (
          <div style={{ 
            padding: '10px', 
            backgroundColor: result.success !== false ? '#d4edda' : '#f8d7da',
            color: result.success !== false ? '#155724' : '#721c24',
            border: `1px solid ${result.success !== false ? '#c3e6cb' : '#f5c6cb'}`,
            borderRadius: '5px'
          }}>
            <p><strong>Status:</strong> {result.success !== false ? '✅ Success' : '❌ Failed'}</p>
            {result.error && <p><strong>Error:</strong> {result.error}</p>}
            {result.timestamp && <p><strong>Timestamp:</strong> {result.timestamp}</p>}
            {result.search && <p><strong>Search API:</strong> {result.search.success ? '✅ Working' : '❌ Failed'}</p>}
            {result.details && <p><strong>Details API:</strong> {result.details.success ? '✅ Working' : '❌ Failed'}</p>}
            {result.categories && <p><strong>Categories API:</strong> {result.categories.success ? '✅ Working' : '❌ Failed'}</p>}
          </div>
        )}
      </div>

      {result && result.search && result.search.success && (
        <div style={{ 
          padding: '15px', 
          backgroundColor: '#e0e0e0', 
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <h3>Sample Data:</h3>
          <p><strong>Search Results:</strong> {result.search.data?.occupations?.length || 0} occupations found</p>
          {result.search.data?.occupations?.map((occ, index) => (
            <div key={index} style={{ marginLeft: '20px', marginTop: '10px' }}>
              <p><strong>{occ.title}</strong> (SOC: {occ.soc_code})</p>
              <p style={{ fontSize: '12px', color: '#666' }}>{occ.description}</p>
            </div>
          ))}
        </div>
      )}

      <div style={{ 
        padding: '10px', 
        backgroundColor: '#fff3cd', 
        color: '#856404',
        border: '1px solid #ffeaa7',
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <h4>Note:</h4>
        <p>This uses mock data for development. Once you get a valid O*NET API key, you can switch back to the real API service.</p>
      </div>

      <div style={{ 
        padding: '10px', 
        backgroundColor: '#e0e0e0', 
        borderRadius: '5px',
        fontSize: '12px'
      }}>
        <h4>Console Logs:</h4>
        <p>Check the browser console for detailed API request/response logs.</p>
      </div>

      {/* O*NET Attribution */}
      <OnetAttribution showBorder={true} />
    </div>
  );
};

export default MockOnetTest;
